<header class="header">
  <div class="container">
    <a class="logo" routerLink="/"><img src="assets/images/logo.png" alt="Data Unveil" /></a>
    <nav class="nav">
      <a *ngFor="let link of navLinks" routerLink="/" [fragment]="link.fragment">{{ link.label }}</a>
    </nav>
    <a class="btn btn-sm" routerLink="/" fragment="contact">Contact Us</a>
  </div>
</header>
